import * as styles from "../firstFlowModals/styles.css";
import * as M from "@discovery/prelude/lib/data/maybe";
import { HeaderVariants, Tags, Typography } from "../../../atoms/typography";
export const ErrorMessage = ({ children }) => {
    return (React.createElement("div", { className: styles.errorCodeWrapper },
        React.createElement(Typography, { classNameM: M.of(styles.pinMismatch), variant: HeaderVariants.headingSix, tag: Tags.h6 },
            React.createElement(React.Fragment, null, children))));
};

